<div class="modal-header">
  <h4 class="modal-title">
    @if (chargesCycle) {
      Editar cobro automatizado
    }

    @if (!chargesCycle) {
      Nuevo cobro automatizado
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <div class="container-fluid">
    <div class="row">

      <div class="col-12 form-group mb-4">
        <label class="form-label">
          Día de corte <span class="text-muted">(1 - 31)</span>
        </label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="cutoffDay"
          min="1"
          max="31"
          placeholder="Día de corte">
      </div>

      <div class="col-12 form-group mb-4">
        <label class="form-label">
          Día límite de pago <span class="text-muted">(1 - 31)</span>
        </label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="maxPaymentDay"
          min="1"
          max="31"
          placeholder="Día límite de pago">
      </div>

    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      type="button"
      class="btn btn-outline-danger w-100"
      (click)="activeModal.dismiss('Cross click')">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="button"
      class="btn btn-primary w-100"
      (click)="onSubmit()">
      {{ chargesCycle ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
